export default "__VITE_ASSET__DIE9QUJk__"